export default {
    userTransaction(state) {
        const chartOption = {
            legend: {
                right: 10,
                top: "center",
                orient: "vertical"
            },
            tooltip: {},
            xAxis: {
                type: "category",
                data: []
            },
            yAxis: {},
            series: []
        };

        if (state.userTransaction) {
            if (state.userTransaction.categories.length > 0) chartOption.xAxis.data = state.userTransaction.categories;

            for (const data of state.userTransaction.series) {
                if (data) {
                    const chartData = { ...data, type: "bar" };
    
                    chartOption.series.push(chartData);
                }
            }
        }

        return chartOption;
    },
    sentimentAnalysis(state) {
        const chartOption = {
            legend: {
                right: 10,
                top: "center",
                orient: "vertical"
            },
            tooltip: {},
            xAxis: {
                type: "category",
                data: []
            },
            yAxis: {},
            series: []
        };

        if (state.sentimentAnalysis) {
            if (state.sentimentAnalysis.categories.length > 0) chartOption.xAxis.data = state.sentimentAnalysis.categories;
            
            for (const data of state.sentimentAnalysis.series) {
                if (data) {
                    const chartData = { ...data, type: "bar" };

                    chartOption.series.push(chartData);
                }
            }
        }

        return chartOption;
    },
    mainCategoriesForSelect(state) {
        const mainCats = [];

        if (state.mainCategories && state.mainCategories.items) {
            for (const mainCat of state.mainCategories.items) {
                mainCats.push({
                    id: `${mainCat.id}`,
                    text: mainCat.value
                });
            }
        }

        return mainCats;
    },
    subCategoriesForSelect(state) {
        const subCats = [];

        if (state.subCategories && state.subCategories.items) {
            for (const subCat of state.subCategories.items) {
                subCats.push({
                    id: `${subCat.id}`,
                    text: subCat.value
                });
            }
        }

        return subCats;
    },
    detailCategoriesForSelect(state) {
        const detailCats = [];

        if (state.detailCategories && state.detailCategories.items) {
            for (const detailCat of state.detailCategories.items) {
                detailCats.push({
                    id: `${detailCat.id}`,
                    text: detailCat.value
                });
            }
        }

        return detailCats;
    },
    operationTransactions(state) {
        return state.operationTransactions;
    },
    userModerationHiddenContents(state) {
        const chartOption = {
            title: {
                text: "Sebep Bazlı Gizleme Raporu",
                left: "center"
            },
            legend: {
                bottom: 0,
                center: "center",
                orient: "horizontal"
            },
            tooltip: {},
            xAxis: {
                type: "category",
                data: []
            },
            yAxis: {},
            series: []
        };

        if (state.userModerationHiddenContents) {
            if (state.userModerationHiddenContents.categories.length > 0) chartOption.xAxis.data = state.userModerationHiddenContents.categories;

            for (const data of state.userModerationHiddenContents.series) {
                if (data) {
                    const chartData = { ...data, type: "bar" };
    
                    chartOption.series.push(chartData);
                }
            }
        }

        return chartOption;
    },
    userModerationBlockedContents(state) {
        const chartOption = {
            title: {
                text: "Sebep Bazlı Engelleme Raporu",
                left: "center"
            },
            legend: {
                bottom: 0,
                center: "center",
                orient: "horizontal"
            },
            tooltip: {},
            xAxis: {
                type: "category",
                data: []
            },
            yAxis: {},
            series: []
        };

        if (state.userModerationBlockedContents) {
            if (state.userModerationBlockedContents.categories.length > 0) chartOption.xAxis.data = state.userModerationBlockedContents.categories;

            for (const data of state.userModerationBlockedContents.series) {
                if (data) {
                    const chartData = { ...data, type: "bar" };
    
                    chartOption.series.push(chartData);
                }
            }
        }

        return chartOption;
    },
    userModerationDeletedContents(state) {
        const chartOption = {
            title: {
                text: "Sebep Bazlı Silme Raporu",
                left: "center"
            },
            legend: {
                bottom: 0,
                center: "center",
                orient: "horizontal"
            },
            tooltip: {},
            xAxis: {
                type: "category",
                data: []
            },
            yAxis: {},
            series: []
        };

        if (state.userModerationDeletedContents) {
            if (state.userModerationDeletedContents.categories.length > 0) chartOption.xAxis.data = state.userModerationDeletedContents.categories;

            for (const data of state.userModerationDeletedContents.series) {
                if (data) {
                    const chartData = { ...data, type: "bar" };
    
                    chartOption.series.push(chartData);
                }
            }
        }

        return chartOption;
    },
    selectedServiceLevelTimePeriods(state) {
        return state.selectedServiceLevelTimePeriods;
    },
    operationServiceLevels(state) {
        return state.operationServiceLevels;
    },
    userTags(state) {
        return state.userTags;
    },
    misalignedResponses(state) {
        return state.misalignedResponses;
    },
    feedFinalizeDetails(state) {
        return state.feedFinalizeDetails;
    },
    feedFinalizeSummaries(state) {
        return state.feedFinalizeSummaries;
    },
    topFeeder(state) {
        return state.topFeeder;
    },
    idleUsers(state) {
        return state.idleUsers;
    }
}